import { render, staticRenderFns } from "./DeliveryCancelDialog.vue?vue&type=template&id=798b0320&scoped=true"
import script from "./DeliveryCancelDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryCancelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b0320",
  null
  
)

export default component.exports